import React, { Component } from 'react'
import Lottie from 'react-lottie'
import animationData from './loader.json'
import animationWhiteData from './loader_white.json'

class OlaLoader extends Component {


  render(){

    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: this.props.dark?animationWhiteData:animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };

    return(
      <>
        <Lottie options={defaultOptions}
              height={this.props.height?this.props.height:40}
              width={this.props.width?this.props.width:40}
        />
      </>
    )
  }
}

export default OlaLoader